import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from './Button';
import { Form } from 'antd';

class LocalFileInputButton extends Component {
  static propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    icon: PropTypes.string,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    label: PropTypes.string,
    formItemLabel: PropTypes.string,
    onClick: PropTypes.func,
    isFormItem: PropTypes.bool,
    accept: PropTypes.oneOf(['audio', 'image', 'video', 'html', 'pdf']),
    errorText: PropTypes.string,
    required: PropTypes.bool,
  };

  static defaultProps = {
    accept: 'audio',
    icon: 'upload',
    label: '',
    value: null,
    disabled: false,
    loading: false,
    isFormItem: false,
  };

  handleChange = (event) => {
    this.props.onChange(event.target.files[0]);
  };

  handleClick = () => {
    this.props.onClick(() => this.fileInput.click());
  };

  renderFileInputButton = () => (
    <>
      <Button
        label={this.props.label}
        disabled={this.props.disabled || this.props.loading}
        onClick={() => (this.props.onClick ? this.handleClick() : this.fileInput.click())}
        icon={this.props.loading ? 'loading' : this.props.icon}
      />
      <input
        type="file"
        style={{
          visibility: 'hidden',
          position: 'absolute',
          width: 0,
          height: 0,
        }}
        onChange={this.handleChange}
        ref={(input) => {
          this.fileInput = input;
        }}
        accept={`${
          {
            audio: 'audio/mpeg,audio/mp3',
            image: 'image/jpeg,image/png',
            video: 'video/mpeg,video/mp4',
            html: 'text/html',
            pdf: 'application/pdf',
          }[this.props.accept]
        }`}
      />
    </>
  );

  render() {
    return this.props.isFormItem ? (
      <Form.Item
        colon={false}
        required={this.props.required}
        label={this.props.formItemLabel}
        help={this.props.errorText}
        validateStatus={this.props.errorText && 'error'}
      >
        {this.renderFileInputButton()}
      </Form.Item>
    ) : (
      this.renderFileInputButton()
    );
  }
}

export default LocalFileInputButton;
